import React from "react";
import PropTypes from "prop-types";
import { getGtmEventClickData } from "./../../utilities/client/analytics";
import ButtonPlayOverlay from "./../ButtonPlayOverlay";
import { ContentfulImage, ContentfulImageAmp } from "./../ContentfulImage";

import {
  StyledImageContainer,
  StyledImageContainerLink,
  StyledButton,
} from "./styles";

const AuthorImage = ({
  context = null,
  clientContext = null,
  contentType,
  imageUrl = null,
  linkPath = null,
  analyticsEvent = {
    category: "author-image",
    value: 100,
    label: "author-image-label",
    action: "click",
    redirect: true,
  },
  width = null,
  height = null,
  schema = null,
  title = null,
  showPlayIcon = false,
  hasHeroVideo = false,
  defaultImageTitle = "Image",
  imageSettings = `&fit=fill&f=faces&fm=webp&q=80`,
  imageLoading = null,
}) => {
  let { isMobile } = clientContext;
  let { isAmp } = context;
  // let { settings } = context.data;

  if (linkPath === null) {
    return (
      <StyledImageContainer
        clientContext={clientContext}
        to={linkPath}
        onClick={(e) => {
          e.preventDefault();
          getGtmEventClickData(e.currentTarget);
        }}
        data-track-hit-type={"event"}
        data-track-event-category={analyticsEvent.category}
        data-track-event-action={analyticsEvent.action}
        data-track-event-label={analyticsEvent.label}
        data-track-event-value={analyticsEvent.value}
        data-track-redirect={analyticsEvent.redirect}
      >
        {isAmp === true ? (
          <ContentfulImageAmp
            clientContext={clientContext}
            context={context}
            url={imageUrl}
            width={width * 2}
            title={title}
            height={height * 2}
            imageSettings={imageSettings}
            defaultImageTitle={defaultImageTitle}
            ampLayout="fixed"
          />
        ) : (
          <ContentfulImage
            clientContext={clientContext}
            context={context}
            url={imageUrl}
            width={width}
            title={title}
            height={height}
            imageSettings={imageSettings}
            defaultImageTitle={defaultImageTitle}
            imageLoading={imageLoading}
          />
        )}
        {showPlayIcon && (
          <StyledButton>
            <ButtonPlayOverlay size="medium" />
          </StyledButton>
        )}
      </StyledImageContainer>
    );
  }
  return (
    <StyledImageContainerLink
      clientContext={clientContext}
      to={linkPath}
      onClick={(e) => {
        e.preventDefault();
        getGtmEventClickData(e.currentTarget);
      }}
      data-track-hit-type={"event"}
      data-track-event-category={analyticsEvent.category}
      data-track-event-action={analyticsEvent.action}
      data-track-event-label={analyticsEvent.label}
      data-track-event-value={analyticsEvent.value}
      data-track-redirect={analyticsEvent.redirect}
    >
      {isAmp === true ? (
        <ContentfulImageAmp
          clientContext={clientContext}
          context={context}
          url={imageUrl}
          width={width * 2}
          title={title}
          height={height * 2}
          imageSettings={imageSettings}
          defaultImageTitle={defaultImageTitle}
          ampLayout="fixed"
          imageLoading={imageLoading}
        />
      ) : (
        <ContentfulImage
          clientContext={clientContext}
          context={context}
          url={imageUrl}
          width={width}
          title={title}
          height={height}
          imageSettings={imageSettings}
          defaultImageTitle={defaultImageTitle}
          imageLoading={imageLoading}
        />
      )}
      {showPlayIcon && (
        <StyledButton>
          <ButtonPlayOverlay size="medium" />
        </StyledButton>
      )}
    </StyledImageContainerLink>
  );
};

export default AuthorImage;

AuthorImage.propTypes = {
  /**
     Client side variables
    */
  clientContext: PropTypes.object,
  /**
     Server side variables
    */
  context: PropTypes.object,
  /**

    */
  contentType: PropTypes.string,
  /**

    */
  imageUrl: PropTypes.string.isRequired,
  /**

    */
  linkPath: PropTypes.string,
  /**

    */
  analyticsEvent: PropTypes.object,
  /**

    */
  width: PropTypes.number.isRequired,
  /**

    */
  height: PropTypes.number.isRequired,
  /**

    */
  schema: PropTypes.string,
  /**

    */
  type: PropTypes.string,
  /**

    */
  title: PropTypes.string.isRequired,
  /**

    */
  showPlayIcon: PropTypes.bool,
  // /**
  //
  //   */
  // hasHeroVideo: PropTypes.boolean, // Unclear what this value is
  /**

    */
  defaultImageTitle: PropTypes.string,
  /**

    */
  imageSettings: PropTypes.string,
  /**
   Loading property for the image.
   */
  imageLoading: PropTypes.string,
};
